<template>
  <div class="bg-white" style="min-height:100%">
    <header-component />

    <main class="container">
      <transition name="slide-left" mode="out-in">
        <router-view />
      </transition>
    </main>

     <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/layouts/partials/FrontendHeader";
import footerComponent from "@/layouts/partials/FrontendFooter";

export default {
  components: {
    headerComponent,
    footerComponent,
  },

  computed: {
    menuState() {
      return this.$store.getters["menu/menuState"];
    },
  },

  methods: {},
};
</script>
<style lang="scss" scoped>

main {
  margin-top: 60px;
  margin-bottom: 60px;
}
</style>
